module.exports = __webpack_public_path__ + "img/head3green.767668ed.png";